export const PREFERRED_NOTARIES = {
  SELECT_LABEL: 'Preferred Notary Search Radius:',
  SELECT_TOOLTIP:
    'Preferred notaries will only be contacted if their home address is within this distance of the signing location.',
  SAVED: 'Saved'
}
